import { render, staticRenderFns } from "./ContractsPriceChangesRecord.vue?vue&type=template&id=f4800454"
import script from "./ContractsPriceChangesRecord.vue?vue&type=script&lang=js"
export * from "./ContractsPriceChangesRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports